module.exports = __webpack_public_path__ + "static/media/fb_logo.84390dcb.png";